import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-action-dialog',
  templateUrl: './action-dialog.component.html',
  styleUrls: ['./action-dialog.component.scss'],
  imports: [MatInputModule, MatButtonModule, FormsModule],
})
export class ActionDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ActionDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  action = { type: '2335', notes: null, futureLikes: false, date: null };
  header = 'I Like It';
  follow_up_type = '2120';

  ngOnInit() {
    const future = new Date();
    future.setDate(future.getDate() + 30);
    this.action.date = future;
    if (this.data.action === 'followUp') {
      this.header = 'Follow Up';
      this.action.type = '2155';
    }
  }

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
  }

  save() {
    this.dialogRef.close({ data: this.action });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
